import { apiService } from '../../../shared/services/apiService';
import {
  CustomerInbodyAccount,
  InbodyAccountInfo,
} from '../../interfaces/customerInbodyAccount';
import {
  CustomerInbodyAccountService,
  GetCustomerInbodyAccountsResponse,
} from './customerInbodyAccountService';

export const nutritionCustomerInbodyAccountService: CustomerInbodyAccountService = {
  async getCustomerInbodyAccounts(customerId: number) {
    const resp = await apiService.get<GetCustomerInbodyAccountsResponse>(
      `/api/coach/users/${customerId}/inbody-data`,
    );

    return resp.data;
  },

  async refreshCustomerInbodyAccount(
    customerId: number,
    inbodyAccountInfo: InbodyAccountInfo,
  ) {
    const resp = await apiService.post<CustomerInbodyAccount>(
      `/api/coach/users/${customerId}/inbody-data`,
      inbodyAccountInfo,
    );

    return resp.data;
  },

  async requestInbodyAccountAccess(
    customerId: number,
    inbodyAccountInfo: InbodyAccountInfo,
  ) {
    const resp = await apiService.post<CustomerInbodyAccount>(
      `api/coach/users/${customerId}/inbody-data/request-access`,
      inbodyAccountInfo,
    );

    return resp.data;
  },
};
